import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=46cfaa24&"
import script from "./userinfo.vue?vue&type=script&lang=js&"
export * from "./userinfo.vue?vue&type=script&lang=js&"
import style0 from "./userinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports